'use strict';

//form validation - verify array has elements
//add a hidden input w/ the array in the ng-model with this directive
//EX: <input style="display:none;" ng-model="myArray" validate-length>
angular.module('cimerFrontEndApp').directive('validateLength', [function() {
    return {
        require: 'ngModel',
        link: function(scope,element,attrs,ngModel) {
            scope.$watch(function() {
                return ngModel.$modelValue && ngModel.$modelValue.length; //watch for changes in the array
            }, function() {
                ngModel.$validate(); //and re-validate on change
            });

            ngModel.$validators.length = function() {
                var arr = ngModel.$modelValue;
                if (!arr) {return false;} //null check
                return arr.length > 0;
            };
        }
    };
}]);
